import { Invoice, InvoiceStatus } from "./types";

export const INVOICES: Invoice[] = [
    { id: "inv1", number: "FAC-2026-0003", date: "2026-03-01", amount: 109, status: "paid",   description: "Plan 60 signatures — annuel 2026" },
    { id: "inv2", number: "FAC-2026-0002", date: "2026-02-01", amount: 54,  status: "paid",   description: "Utilisateur supplémentaire — prorata" },
    { id: "inv3", number: "FAC-2026-0001", date: "2026-01-01", amount: 29,  status: "paid",   description: "Pack 120 signatures" },
    { id: "inv4", number: "FAC-2025-0012", date: "2025-12-01", amount: 109, status: "paid",   description: "Plan 60 signatures — annuel 2025" },
    { id: "inv5", number: "FAC-2025-0011", date: "2025-11-01", amount: 109, status: "failed", description: "Plan 60 signatures — annuel 2025" },
];
 
export const STATUS_STYLES: Record<InvoiceStatus, { label: string; bg: string; color: string }> = {
    paid:    { label: "Payée",      bg: "#f0fdf4", color: "#15803d" },
    pending: { label: "En attente", bg: "#fffbeb", color: "#b45309" },
    failed:  { label: "Échouée",   bg: "#fef2f2", color: "#dc2626" },
};